
const UPPERCASE_TOKENS = new Set([
  "N","S","E","W","NE","NW","SE","SW","NNE","NNW","SSE","SSW","ENE","ESE","WNW","WSW",
  "ST","AVE","BLVD","DR","RD","CT","CIR","LN","PL","TER","WAY","HWY","PKWY","FWY",
  "SQ","LOOP","XING","EXT","APT","STE","UNIT","FL","BLDG","RM","LOT","PO","BOX",
]);

const ALIASES = {
  "STREET":"ST","AVENUE":"AVE","BOULEVARD":"BLVD","DRIVE":"DR","ROAD":"RD",
  "COURT":"CT","CIRCLE":"CIR","LANE":"LN","PLACE":"PL","TERRACE":"TER",
  "HIGHWAY":"HWY","PARKWAY":"PKWY","FREEWAY":"FWY","TRAIL":"TRL","CROSSING":"XING",
  "SUITE":"STE","APARTMENT":"APT","FLOOR":"FL","BUILDING":"BLDG",
  "NORTH":"N","SOUTH":"S","EAST":"E","WEST":"W",
  "NORTHEAST":"NE","NORTHWEST":"NW","SOUTHEAST":"SE","SOUTHWEST":"SW",
};

const formatAddress = (raw) => {
  if (!raw) return raw;
  return raw
    .replace(/(\d+)(st|nd|rd|th)/gi, "$1$2")  // protect ordinals FIRST: 62nd stays 62nd
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")       // then split letter→digit
    .replace(/(\d)([a-zA-Z])/g, "$1 $2")       // then split digit→letter (won't touch 62nd now)
    .split(/\s+/)
    .map((word) => {
      if (!word) return "";
      const upper = word.toUpperCase();
      if (ALIASES[upper]) return ALIASES[upper];
      if (UPPERCASE_TOKENS.has(upper)) return upper;
      if (/^\d+$/.test(word)) return word;
      if (/^\d+(st|nd|rd|th)$/i.test(word)) return word.replace(/[a-z]+$/i, m => m.toUpperCase());
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ")
    .trim();
};



function ShippingAddressCardInvoice({ order }) {






  const customer = order?.customer || {};
  const shipping = order?.shippingAddress || {};

  return (

    <div style={styles.card}>

      <div style={styles.title}>
        Shipping Address
      </div>

      <div style={styles.text}>
        {customer.firstName} {customer.lastName}
      </div>

   <div style={styles.text}>
  {formatAddress(shipping.address)}
</div>

{shipping.apartment && (
  <div style={styles.text}>
    {formatAddress(shipping.apartment)}
  </div>
)}


      <div style={styles.text}>
        {shipping.city}, {shipping.state} {shipping.zip}
      </div>

      <div style={styles.divider}></div>

      <div style={styles.delivery}>
        Estimated Delivery:
        <b>
          {" "}
          {order?.createdAt
            ? new Date(
                new Date(order.createdAt).getTime() +
                (4 * 24 * 60 * 60 * 1000)
              ).toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric"
              })
            : "—"}
        </b>
      </div>

      <div style={styles.delivery}>
        Shipping Method:
        <span style={styles.free}>
          {" "}FREE Delivery
        </span>
      </div>

    </div>

  );

}






export default ShippingAddressCardInvoice;

const styles = {

  card:{
    padding:30,
    borderRadius:22,

    background:"linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",

    border:"2px solid #ffffff",

    boxShadow:
    "0 0 30px rgba(120,170,255,0.18), \
     0 20px 50px rgba(0,0,0,0.10), \
     0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,1)"
  },

  title:{
    fontSize:18,
    fontWeight:600,
    marginBottom:16,
    color:"#1D1D1F"
  },

  text:{
    fontSize:15,
    marginBottom:4,
    color:"#1D1D1F"
  },

  divider:{
    height:1,
    background:"rgba(0,0,0,0.06)",
    margin:"18px 0"
  },

  delivery:{
    fontSize:15,
    marginBottom:6,
    color:"#1D1D1F"
  },

  free:{
    color:"#2D6CFF",
    fontWeight:500
  }

};